const request = async (targetUrl = '') => {
  const url = `${process.env.REACT_APP_API_DOMAIN}/proxy`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'targetUrl': targetUrl
      },
    });

    const jsonResponse = await response.json();

    if (!jsonResponse) {
      return null;
    } else {
      return jsonResponse;
    }
  } catch (e) {
    console.error(e);
  }

  return null;
};

export default {
  request,
};
